export default class CountMeasureFieldDto {
  constructor(options = {}) {
    this.name = options.name || '';
    this.label = options.label || '';
    this.type = options.type || '';
    this.total = options.total || 0;
  }
}